<tix-card>
  <tix-card-header>
    <div class="mb-3.5 relative">
      <tix-card-title>Roles</tix-card-title>
      <span
        class="text-primary material-icons cursor-pointer absolute -top-1 left-[2.9rem]"
        matTooltip="Click for more info"
        (click)="openHelpDialog()"
        >info</span
      >
    </div>
  </tix-card-header>
  <tix-card-content *ngIf="userRolesForm">
    <form class="profile-content-layout" [formGroup]="userRolesForm">
      <div class="permission-box-layout" *ngFor="let item of roleList">
        <tix-checkbox
          [labelPosition]="'before'"
          [formControlName]="item.key"
          value="test"
          (change)="onChange($event, item)"
          [disabled]="keepDisableSaveBtn"
        >
          {{ item.title }}
        </tix-checkbox>
      </div>
    </form>
  </tix-card-content>
  <tix-card-actions
    class="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-end"
  >
    <button
      mat-button
      (click)="onSave()"
      class="w-full sm:w-auto min-w-[160px] px-6 py-1.5 sm:py-1 bg-primary text-white font-medium"
      [ngClass]="[
        userRolesForm.pristine ||
        isloading ||
        userRolesForm.invalid ||
        (isSaving$ | async)
          ? 'cursor-not-allowed'
          : 'cursor-pointer',
        userRolesForm.pristine ||
        isloading ||
        userRolesForm.invalid ||
        ((isSaving$ | async) && !isloading)
          ? 'hover:bg-gray-300 hover:text-gray-700 hover:opacity-50'
          : 'hover:bg-primary-700'
      ]"
      [disabled]="
        userRolesForm.pristine ||
        isloading ||
        userRolesForm.invalid ||
        (isSaving$ | async)
      "
    >
      <div *ngIf="!isloading" class="flex items-center justify-center">
        <span class="material-icons-outlined mr-2 text-lg">save</span>
        <span>Save Changes</span>
      </div>
      <div *ngIf="isloading" class="flex items-center justify-center space-x-2">
        <span class="mr-2" *tixBtnLoading="isloading"></span>
        <span>Loading</span>
      </div>
    </button>
  </tix-card-actions>
</tix-card>
